module.exports = __webpack_public_path__ + "img/job-heavy-manual.3deb8fbc.svg";